import styled from '@emotion/styled';

const Bars = styled.span`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 5px;
	width: 2.4rem;
	height: 2.4rem;
	pointer-events: none;
`;

const Bar = styled.span<{ $open: boolean; $i: number }>`
	display: block;
	width: 2.2rem;
	height: 2px;
	border-radius: 1px;
	background: currentColor;
	transform-origin: center;
	transition:
		transform 0.32s cubic-bezier(0.4, 0, 0.2, 1),
		opacity 0.22s ease;
	${(p) =>
		p.$open &&
		p.$i === 0 &&
		`
		transform: translateY(7px) rotate(45deg);
	`}
	${(p) =>
		p.$open &&
		p.$i === 1 &&
		`
		opacity: 0;
		transform: scaleX(0);
	`}
	${(p) =>
		p.$open &&
		p.$i === 2 &&
		`
		transform: translateY(-7px) rotate(-45deg);
	`}
`;

const Root = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	margin: 0;
	border: none;
	background: transparent;
	cursor: pointer;
	color: inherit;
	-webkit-tap-highlight-color: transparent;
	&:focus-visible {
		outline: 2px solid currentColor;
		outline-offset: 3px;
		border-radius: 4px;
	}
`;

interface Props {
	/** 열림 = X 모양 */
	open: boolean;
	/** 선 색 (헤더 텍스트와 동일 톤) */
	color: string;
	onClick: () => void;
	ariaExpanded: boolean;
	ariaLabel: string;
}

/**
 * 햄버거 세 줄 ↔ X 한 점(교차)으로 이어지는 모션
 */
const HamburgerToggle = ({ open, color, onClick, ariaExpanded, ariaLabel }: Props) => (
	<Root type="button" onClick={onClick} style={{ color }} aria-expanded={ariaExpanded} aria-label={ariaLabel}>
		<Bars aria-hidden>
			<Bar $open={open} $i={0} />
			<Bar $open={open} $i={1} />
			<Bar $open={open} $i={2} />
		</Bars>
	</Root>
);

export default HamburgerToggle;
